import React from 'react';
import { formatDateStrWithYearShort } from 'utils';
import styled from 'styled-components';
import { RecipientType } from '../OfferMessageSentPage/types';
import { ListingAgentType } from './types';

interface AgentInfoProps {
  agent: ListingAgentType | RecipientType;
  handleClick?: (agentEmail: string, agentId?: string) => void;
  buttonText?: 'Restore' | 'Remove';
}

function AgentInfo({ agent, handleClick, buttonText }: AgentInfoProps) {
  return (
    <div className="panel-body note-link m-t-sm" key={agent.email}>
      <AgentDetailContainer>
        <div className="offer-message-agent-detail">
          {agent.name}
          <br />
          {agent.org}
          <br />
          {agent.email}
          {'appointment' in agent && agent.appointment && (
            <div>
              <hr style={{ margin: '0' }} />
              <small>
                Showing Details:{' '}
                {`${formatDateStrWithYearShort(
                  agent.appointment.time,
                  agent.appointment.timezone,
                )}`}
              </small>
              <br />
              <small>Showing Status: {agent.appointment.displayStatus}</small>
            </div>
          )}
        </div>
        {buttonText && (
          <div className="offer-message-agent-button">
            <a
              className={buttonText === 'Remove' ? 'text-danger' : 'text-info'}
              onClick={() => {
                handleClick?.(agent.email, agent.id);
              }}
            >
              {buttonText === 'Remove' ? (
                <i className="fa fa-times"></i>
              ) : (
                <i className="fa fa-plus"></i>
              )}
              <strong>{buttonText}</strong>
            </a>
          </div>
        )}
      </AgentDetailContainer>
    </div>
  );
}

export default AgentInfo;

const AgentDetailContainer = styled.div`
  display: flex;

  .offer-message-agent-detail {
    flex-grow: 2;
  }

  .offer-message-agent-button {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    border-left: 1px solid #eee;
  }
`;
